import { makeStyles } from "../Utilities/ThemeHelper";
export const useStyles = makeStyles(theme => ({
  root: {
    flexDirection: "row",
    position: "relative"
  },
  component: {
    display: "flex",
    padding: theme.spacing(0, 0.5),
    "&:first-child": {
      paddingLeft: 0
    },
    "&:last-child": {
      paddingRight: 0
    }
  },
  componentFullWidth: {
    flexBasis: "50%",
    maxWidth: "50%" // IE doesn't respect box-sizing for flex basis calculation, but it does for max-width
  },
  rangeLabel: {
    color: theme.palette.primary.main,
    display: "block",
    fontSize: theme.typography.caption.fontSize,
    fontWeight: "bold",
    position: "absolute",
    top: theme.spacing(-2),
    // matches the padding provided by FormControl
    left: theme.spacing(0.5) // match padding
  }
}));
export default useStyles;